// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlertTwoToneSvg from "@ant-design/icons-svg/es/asn/AlertTwoTone";
import AntdIcon from '../components/AntdIcon';

var AlertTwoTone = function AlertTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlertTwoToneSvg
  }));
};

AlertTwoTone.displayName = 'AlertTwoTone';
export default React.forwardRef(AlertTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlertTwoTone.js
// module id = 533
// module chunks = 0